<via-error>
  <h1>
    {{ "errors.conflict.title" | transloco }}
  </h1>

  <via-back-to-dashboard-button>
    {{ "button.home" | transloco }}
  </via-back-to-dashboard-button>
</via-error>
